import { DateTime } from "luxon";
import {
  OPTION_TACHES_TERMINEES,
  PROCHAINE_TACHE_TERMINE,
} from "../../../../helpers/leadTasksOrder";
import { LEAD_AUTO_FILTERS_DEFAULT } from "../leadAutoFiltersDefault";
import { agentLabel, devisLabel, etapeLabel, statusLabel } from "./leadAutoPresets";

const fmtDate = (ymd) => (ymd ? DateTime.fromISO(ymd).toFormat("dd/MM/yy") : "");

// Patch « remettre ce champ à sa valeur par défaut ».
const vide = (key) => ({ [key]: LEAD_AUTO_FILTERS_DEFAULT[key] });

/**
 * Jetons de la ligne de résumé : { key, label, clear }.
 * ctx = { userId, managers, LEAD_STATUS, leadTasks } — tous optionnels
 * (les libellés dégradent sur l'id brut).
 */
export const buildFilterTokens = (filters, ctx = {}) => {
  const tokens = [];

  if (filters.terms) {
    tokens.push({ key: "terms", label: `« ${filters.terms} »`, clear: vide("terms") });
  }

  if (filters.statuses?.length) {
    const label = filters.statuses
      .map((id) => {
        const status = ctx.LEAD_STATUS?.find((s) => s.id === id);
        return status ? statusLabel(status) : id;
      })
      .join(", ");
    tokens.push({ key: "statuses", label, clear: vide("statuses") });
  }

  if (filters.assignedTo?.length) {
    const onlyMe =
      filters.assignedTo.length === 1 && filters.assignedTo[0] === ctx.userId;
    let label;
    if (onlyMe) {
      label = "Assigné : moi";
    } else if (filters.assignedTo.length <= 2) {
      label =
        "Assigné : " +
        filters.assignedTo
          .map((id) => ctx.managers?.find((m) => m.id === id)?.fullName || "?")
          .join(", ");
    } else {
      label = `Assigné : ${filters.assignedTo.length} personnes`;
    }
    tokens.push({ key: "assignedTo", label, clear: vide("assignedTo") });
  }

  // Étape (PER-2428) : un seul jeton pour les deux clés isEstimated / isFinalized
  const etape = etapeLabel(filters);
  if (etape) {
    tokens.push({
      key: "etape",
      label: etape,
      clear: { ...vide("isEstimated"), ...vide("isFinalized") },
    });
  }

  // Agent de tarification (PER-2433)
  const agent = agentLabel(filters);
  if (agent) {
    tokens.push({ key: "agentEtats", label: `Agent : ${agent}`, clear: vide("agentEtats") });
  }

  const devis = devisLabel(filters);
  if (devis) {
    tokens.push({ key: "devisDepose", label: `Devis : ${devis}`, clear: vide("devisDepose") });
  }

  if (filters.beginAt || filters.endAt) {
    tokens.push({
      key: "period",
      label: `${fmtDate(filters.beginAt) || "…"} → ${fmtDate(filters.endAt) || "…"}`,
      clear: { ...vide("beginAt"), ...vide("endAt") },
    });
  }

  if (filters.prochaineTache) {
    const label =
      filters.prochaineTache === PROCHAINE_TACHE_TERMINE
        ? OPTION_TACHES_TERMINEES.name
        : "Prochaine : " +
          (ctx.leadTasks?.find((t) => t.id === filters.prochaineTache)?.name ||
            filters.prochaineTache);
    tokens.push({ key: "prochaineTache", label, clear: vide("prochaineTache") });
  }

  return tokens;
};

// Badge du bouton « Filtres » : nombre de jetons, sans avoir besoin du ctx.
export const countActiveFilters = (filters = {}) => buildFilterTokens(filters).length;
